"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonControlsHyperlink = exports.TextboxStateWrapper = exports.Button = exports.UploadViewer = exports.LayoutControlsGridCol = exports.LayoutControlsGridLayout = exports.CommonControlsText = exports.CommonControlsSectionHeader = exports.LayoutControlsPanel = exports.ApplicationWorkflowCoverLetter = void 0;
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var Panel_1 = require("player-layout-controls/controls/Panel");
Object.defineProperty(exports, "LayoutControlsPanel", { enumerable: true, get: function () { return Panel_1.Panel; } });
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
Object.defineProperty(exports, "CommonControlsSectionHeader", { enumerable: true, get: function () { return SectionHeader_1.SectionHeader; } });
var Text_1 = require("player-common-controls/controls/Text");
Object.defineProperty(exports, "CommonControlsText", { enumerable: true, get: function () { return Text_1.Text; } });
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
Object.defineProperty(exports, "LayoutControlsGridLayout", { enumerable: true, get: function () { return GridLayout_1.GridLayout; } });
var GridCol_1 = require("player-layout-controls/controls/GridCol");
Object.defineProperty(exports, "LayoutControlsGridCol", { enumerable: true, get: function () { return GridCol_1.GridCol; } });
var UploadViewer_1 = require("../UploadViewer/UploadViewer");
Object.defineProperty(exports, "UploadViewer", { enumerable: true, get: function () { return UploadViewer_1.UploadViewer; } });
var player_button_1 = require("player-button");
exports.Button = player_button_1.default;
var TextboxStateWrapper_1 = require("../TextboxStateWrapper/TextboxStateWrapper");
Object.defineProperty(exports, "TextboxStateWrapper", { enumerable: true, get: function () { return TextboxStateWrapper_1.TextboxStateWrapper; } });
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
Object.defineProperty(exports, "CommonControlsHyperlink", { enumerable: true, get: function () { return Hyperlink_1.Hyperlink; } });
var ApplicationWorkflowCoverLetter = (function (_super) {
    __extends(ApplicationWorkflowCoverLetter, _super);
    function ApplicationWorkflowCoverLetter(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign(__assign({}, _this.view.state), _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    ApplicationWorkflowCoverLetter.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign(__assign({}, _this.view.state), _this.props)
                });
            })
            : null;
    };
    ApplicationWorkflowCoverLetter.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    ApplicationWorkflowCoverLetter.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    ApplicationWorkflowCoverLetter.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign(__assign(__assign({}, this.state.viewModel), this.view.state), this.props)
        }, cb ? cb : function () { });
    };
    ApplicationWorkflowCoverLetter.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign(__assign(__assign({}, viewModel), viewState), props) });
    };
    ApplicationWorkflowCoverLetter.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    ApplicationWorkflowCoverLetter.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    ApplicationWorkflowCoverLetter.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    ApplicationWorkflowCoverLetter.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Small", children: [React.createElement(SectionHeader_1.SectionHeader, { key: 0, size: "H2", text: $this.state.viewModel.coverLetterTitle, tag: "coverLetter_title", id: "coverLetter_title" }), React.createElement(PlayerVisible, { key: 1, visible: $this.state.viewModel.actionItem.isRequired, children: [React.createElement(Text_1.Text, { key: 0, text: "*", color: "Error", size: "Large" })] })] }), React.createElement(GridLayout_1.GridLayout, { key: 1, children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", isVisible: $this.state.viewModel.isFileUploadVisible, children: [React.createElement(UploadViewer_1.UploadViewer, { key: 0, fileUploadText: $this.state.viewModel.uploadButtonText, fileUploadId: "cover_letter_file_upload", fileViewerId: "cover_letter_file_upload", showUpload: $this.state.viewModel.showFileUpload, fileUploadWidth: "Block", guid: $this.state.viewModel.actionItem.fileUploadToken.value, fileName: $this.state.viewModel.actionItem.fileUploadToken.title, fileSize: $this.state.viewModel.actionItem.fileUploadToken.fileSize, fileUrl: $this.state.viewModel.actionItem.fileUploadToken.fileUrl, fileIconName: $this.state.viewModel.actionItem.fileUploadToken.fileIcon, fileIconBackgroundColor: $this.state.viewModel.actionItem.fileUploadToken.fileIconBackgroundColor, fileUploadError: $this.state.viewModel.actionItem.fileUploadToken.errorMessage, accept: [".docx", ".doc", ".pdf", ".txt"], sizeLimit: 5242880, maxFileNameLength: 50, fileSizeErrorMessage: $this.state.viewModel.fileSizeErrorMessage, fileDeleteMessage: $this.state.viewModel.fileDeleteMessage, fileNameLengthErrorMessage: $this.state.viewModel.fileNameLengthErrorMessage, fileTypeErrorMessage: $this.state.viewModel.fileTypeErrorMessage, fileUploadIsEnabled: $this.state.viewModel.fileUploadIsEnabled, onSuccess: _this._proxyEvent("onCoverLetterUploadSuccess"), onError: _this._proxyEvent("onCoverLetterUploadError"), onDelete: _this._proxyEvent("onCoverLetterDelete"), onLoadingChanged: _this._proxyEvent("onLoadingChanged") })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "6", offsetRightForSm: "6", widthForMd: "4", offsetRightForMd: "8", isVisible: $this.state.viewModel.isOrTextVisible, children: [React.createElement(Panel_1.Panel, { key: 0, horizontalAlign: "Center", paddingVertical: "Xsmall", children: [React.createElement(Text_1.Text, { key: 0, text: $this.state.viewModel.orText })] })] }), React.createElement(GridCol_1.GridCol, { key: 2, width: "12", isVisible: $this.state.viewModel.isManualCoverLetterVisible, children: [React.createElement(GridLayout_1.GridLayout, { key: 0, children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "6", offsetRightForSm: "6", widthForMd: "4", offsetRightForMd: "8", isVisible: !$this.state.viewModel.showManualEntry, children: [React.createElement(player_button_1.default, { key: 0, text: $this.state.viewModel.manualEntryText, color: "Grey", iconName: "pencil", width: "Block", onClick: _this._proxyEvent("onClickManualEntry") })] }), React.createElement(GridCol_1.GridCol, { key: 1, width: "12", isVisible: $this.state.viewModel.showManualEntry, children: [React.createElement(TextboxStateWrapper_1.TextboxStateWrapper, { key: 0, height: "Medium", isEnabled: true, showLabel: false, type: "Text", value: $this.state.viewModel.actionItem.coverLetterText, ariaLabeledBy: "coverLetter_title", onChange: _this._proxyEvent("onChangeCoverLetterText") }), React.createElement(Hyperlink_1.Hyperlink, { key: 1, type: "Action", onClick: _this._proxyEvent("onDeleteManualEntry"), children: [React.createElement(Text_1.Text, { key: 0, text: $this.state.viewModel.cancelCoverLetterText, color: "Error", weight: "SemiBold" })] })] })] })] }), React.createElement(GridCol_1.GridCol, { key: 3, width: "12", children: [React.createElement(Text_1.Text, { key: 0, role: "alert", color: "Error", text: $this.state.viewModel.actionItem.errorMessage })] })] })];
        };
        return (React.createElement("div", { className: "p-view-applicationworkflowcoverletter" }, this.state.isInit ? root_handler() : null));
    };
    ApplicationWorkflowCoverLetter.defaultProps = {
        actionItem: "", coverLetterTitle: "", uploadButtonText: "", orText: "", manualEntryText: "", fileUploadErrorMessage: "", fileSizeErrorMessage: "", fileDeleteMessage: "", fileNameLengthErrorMessage: "", fileTypeErrorMessage: "",
        onDataChanged: function () { }, onLoadingChanged: function () { }
    };
    return ApplicationWorkflowCoverLetter;
}(React.Component));
exports.ApplicationWorkflowCoverLetter = ApplicationWorkflowCoverLetter;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["ApplicationWorkflowCoverLetter"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplicationWorkflowCoverLetter/ApplicationWorkflowCoverLetter.js
// module id = 405
// module chunks = 0 2